import { loadSectionContent } from "./product_page"
import { bindGenerateLibraryUrl } from "../api_token/generate_library_url"

$(document).on("turbolinks:load", function () {
  if ($("#js-tab-content-assets.loaded").length) initializeAssetsTabHandlers()
})

export function initializeAssetsTabHandlers() {
  let $assetsSection = $("#js-tab-content-assets")

  // The owner CTA modal arrives with the XHR-injected panel.
  bindGenerateLibraryUrl()

  $assetsSection.find(".js-pagyContainer .page-link").each(function () {
    $(this).on("click", function (e) {
      e.preventDefault()
      let $this = $(this)

      if (!$this.parent().hasClass("active")) {
        loadSectionContent($assetsSection, $this.attr("href"), true)
      }
    })
  })

  $assetsSection.find(".js-asset-type-filter").on("change", function () {
    let url = new URL($(this).data("url"), window.location.origin)
    if (this.value) url.searchParams.set("asset_type", this.value)

    loadSectionContent($assetsSection, url.toString())
  })
}
